import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TableColumn } from 'react-data-table-component';

import Arrow from 'src/assets/arrow-left-black.svg';

import { RegularButton, SearchInput } from 'pg-ui-library';

import useDebounce from 'src/hooks/useDebounce';
import { SettingsButton } from 'src/components';

import BenefitsMasterService from 'src/services/benefits-master.service';
import { IBenefitListTable } from 'src/interfaces';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  ItemContainer,
  ArrowBack,
  NavTextLink,
  ItemContainerHeader,
  PageTitle,
  HeaderLeftItems,
  HeaderRightItems,
  HeaderLeftFirstItem,
  HeaderLeftSecondItem,
  TableSettingContainer,
} from './styles';
import EnrollmentUploadModal from '../enrollment-upload';
import { benefitsListInitialColumns, BenefitsListTable } from '../benefits-list-table';

const BenefitsManagementList: React.FC = () => {
  const { t } = useTranslation();
  const [columns, setColumns] = useState<TableColumn<IBenefitListTable>[]>(benefitsListInitialColumns);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  // Debounce the search term so that we only perform the search
  // after the user has stopped typing for 500ms
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  return (
    <Container>
      <EnrollmentUploadModal isOpen={isOpen} setIsOpen={setIsOpen} />
      <ItemContainerHeader>
        <HeaderLeftItems>
          <HeaderLeftFirstItem>
            <NavTextLink to="/benefits">
              <ArrowBack src={Arrow} />
            </NavTextLink>
            <PageTitle>{t('benefits.management.title')}</PageTitle>
          </HeaderLeftFirstItem>
          <HeaderLeftSecondItem />
        </HeaderLeftItems>
        <HeaderRightItems>
          <SearchInput
            value={searchTerm}
            placeholder="Search..."
            handleChange={event => {
              setSearchTerm(event.target.value);
            }}
          />
          <RegularButton onClick={() => setIsOpen(true)}>
            {t('benefits.management.header.uploadBenefits')}
          </RegularButton>
          <a href={BenefitsMasterService.downloadBenefitsMaster()} target="_blank" rel="noopener noreferrer">
            <RegularButton>{t('benefits.management.header.downloadExcel')}</RegularButton>
          </a>
          <RegularButton onClick={() => navigate('/benefits/version-management')}>
            {t('benefits.management.header.maintainVersion')}
          </RegularButton>
        </HeaderRightItems>
      </ItemContainerHeader>
      <ItemContainer>
        <TableSettingContainer>
          <SettingsButton columns={columns} setColumns={setColumns} />
        </TableSettingContainer>
        <BenefitsListTable key={0} searchTerm={debouncedSearchTerm} columns={columns} />
      </ItemContainer>
    </Container>
  );
};
export default BenefitsManagementList;
